import React, { useEffect, useState } from 'react';
import { userData } from '../../../util/userData';
import { loadAllComments, selectAllCommentsState } from '../AllComments/allCommentsSlice';
import { AllCommentComponent } from '../AllComments/index';
import { loadCommentCategories } from '../CommentCategories/commentCategoriesSlice';
import { CommentCategoriesComponent } from '../CommentCategories/index';
import { CommentsMoodComponent } from '../CommentMoods';
import { loadCommentMoods, selectCommentMoods } from '../CommentMoods/commentMoodsSlice';
import { CommentTrendComponent } from '../CommentTrend';
import { loadCommentTrend } from '../CommentTrend/commentTrendSlice';
import { selectFilters, updateFilters } from '../filters/filtersSlice';
import { useAppDispatch, useAppSelector } from '../hooks';
import { WellComponent } from './WellComponent';

export function CommentsDashboardComponent() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFilters);
  const [showWell, setShowWell] = useState(false);
  const { commentMood } = useAppSelector(selectAllCommentsState);
  const moods = useAppSelector(selectCommentMoods);

  useEffect(() => {
    userData.filtersListen((updatedFilters) => {
      dispatch(updateFilters(updatedFilters));
    });
    // @ts-ignore
    window.removeComment();
  }, []);

  useEffect(() => {
    if (Object.keys(filters).length) {
      dispatch(loadAllComments(filters));
      dispatch(loadCommentCategories(filters));
      dispatch(loadCommentMoods(filters));
      dispatch(loadCommentTrend(filters));
    }
    if (filters.comment && filters.commentType) {
      setShowWell(true);
    } else {
      setShowWell(false);
    }
  }, [filters]);

  return (
    <div className="blacklight">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <p className="dashboardTitle">
              {moods.apiResponse && moods.apiResponse.surveyLabel ? `${moods.apiResponse.surveyLabel} Comments` : 'Comments'}&nbsp;&nbsp;
              <span className="dashboard-legend">
                <img src="images/compliment_circle.png?v=3.1" /> Compliment &nbsp; /
                &nbsp;
                <img src="images/suggestion_circle.png?v=3.1" /> Suggestion &nbsp; /
                &nbsp;
                <img src="images/neutral_circle.png?v=3.1" /> Neutral
              </span>
              <br />
            </p>
          </div>
        </div>
        {moods.chartSubtitle && (
          <div className="row">
            <div className="col-sm-12">
              <span className="survey-title">{moods.dashboardSubtitle}</span>
            </div>
          </div>
        )}
        {showWell && (
          <div className="row">
            <div className="col-sm-12">
              <WellComponent
                comment={filters.comment ? filters.comment.toString() : ''}
                commentType={
                  filters.commentType ? filters.commentType.toString() : ''
                }
                commentCategory={commentMood}
              />
            </div>
          </div>
        )}
        <div className="row mt-3">
          <div className="col-sm-12 col-md-6">
            <div className="row">
              <div className="col-sm-6">
                <CommentsMoodComponent />
              </div>
              <div className="col-sm-6">
                <CommentTrendComponent />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <CommentCategoriesComponent />
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6">
            <AllCommentComponent />
          </div>
        </div>
      </div>
    </div>
  );
}
